import type { DirectionalIndicatorEdge } from '../core';

/**
 * Maps (oldIndex, hovered item index, pointer edge) to the `to` index for
 * {@link arrayMove} so reorder matches “insert before/after this slot” rather
 * than only “land on this card’s index”.
 */
export function resolveCollectionReorderTargetIndex({
  oldIndex,
  overIndex,
  edge,
}: {
  oldIndex: number;
  overIndex: number;
  edge: DirectionalIndicatorEdge;
}): number {
  if (oldIndex === overIndex) {
    return oldIndex;
  }

  const insertAfter = edge === 'right' || edge === 'bottom';
  let newIndex = insertAfter ? overIndex + 1 : overIndex;
  if (oldIndex < newIndex) {
    newIndex -= 1;
  }

  return Math.max(0, newIndex);
}
